// Chiavi delle tabelle base (base_*) usate per identificare specifiche righe
// di seed indipendentemente dal loro Id numerico. Centralizzate qui per evitare
// magic string sparsi nei componenti.

// base_tipo_anagrafica (vedi migration 18_base_tipo_anagrafica)
export const TIPO_ANAGRAFICA_CLIENTE_PF_KEY = "tipo_anagrafica_1"; // Cliente Persona fisica
export const TIPO_ANAGRAFICA_CLIENTE_PG_KEY = "tipo_anagrafica_2"; // Cliente Persona giuridica
export const TIPO_ANAGRAFICA_LEGALE_RAPP_KEY = "tipo_anagrafica_3"; // Legale rappresentante
export const TIPO_ANAGRAFICA_PROCURATORE_KEY = "tipo_anagrafica_4"; // Procuratore delegato
export const TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY = "tipo_anagrafica_5"; // Titolare effettivo

// base_tipo_documento (vedi migration 10_base_tipo_documento)
// La tabella è per-tenant: oltre a queste righe di sistema un tenant può avere voci
// proprie (IsSystem = false), quindi la risoluzione va sempre fatta per chiave.
export const TIPO_DOCUMENTO_CARTA_IDENTITA_KEY = "tipo_documento_1"; // Carta d'identità (PF)
export const TIPO_DOCUMENTO_PASSAPORTO_KEY = "tipo_documento_2"; // Passaporto (PF)
export const TIPO_DOCUMENTO_VISURA_CAMERALE_KEY = "tipo_documento_3"; // Visura camerale (PG)
export const TIPO_DOCUMENTO_PERMESSO_SOGGIORNO_KEY = "tipo_documento_4"; // Permesso di soggiorno (PF)
export const TIPO_DOCUMENTO_PATENTE_GUIDA_KEY = "tipo_documento_5"; // Patente di guida (PF)
export const TIPO_DOCUMENTO_PORTO_ARMI_KEY = "tipo_documento_6"; // Porto d'armi (PF)
export const TIPO_DOCUMENTO_PATENTE_NAUTICA_KEY = "tipo_documento_7"; // Patente nautica (PF)
export const TIPO_DOCUMENTO_ALTRO_EQUIPOLLENTE_KEY = "tipo_documento_8"; // Altro documento equipollente (art. 35 DPR 445/2000)

// base_tipo_partecipazione (vedi migration 21_base_tipo_partecipazione)
// La voce "Nessuna delle altre tipologie" ("Altro"), che richiede la descrizione libera.
export const TIPO_PARTECIPAZIONE_ALTRO_KEY = "tipo_partecipazione_10";

// base_paese (vedi migration 4_base_paese)
// L'Italia si identifica tramite "Identificativo", non tramite il nome: è il codice
// su cui il form decide se mostrare le tendine dei comuni o i campi liberi.
export const PAESE_IDENT_ITALIA = "ITA";
